export enum SessionType {
  WORK = 'WORK',
  SHORT_BREAK = 'SHORT_BREAK',
  LONG_BREAK = 'LONG_BREAK'
}

export interface TimerState {
  timeLeft: number; // in seconds
  sessionType: SessionType;
  isRunning: boolean;
  isCompleted: boolean;
  pomodoroCount: number; // 1-4 in current cycle
  totalPomodoros: number; // total completed today
}

export interface TimerSettings {
  workDuration: number; // in minutes
  shortBreakDuration: number; // in minutes
  longBreakDuration: number; // in minutes
  autoStart: boolean;
  soundEnabled: boolean;
}

// New types for daily Pomodoro statistics
export interface DailyPomodoroStats {
  date: string; // YYYY-MM-DD format
  completedPomodoros: number;
  fullCycles: number;
}

export interface PomodoroStatsData {
  dailyStats: DailyPomodoroStats[];
  totalPomodoros: number;
  totalCycles: number;
  currentStreak: number;
  bestStreak: number;
}

export interface PomodoroSession {
  id: string;
  type: SessionType;
  duration: number; // in seconds
  completedAt: Date;
  interrupted: boolean;
} 